import API from "@/js/api/masters.js";
//import config from 'config';

const defaultState = {
  masters: [],
  mastersCount: 0,
  currentMaster: {}
};

const actions = {
  GET_MASTER(context, data) {
   Logger.debug("GET_MASTER", data);
    return API.getDocument(data)
      .then(response => {
       Logger.debug("MASTER ACTION GET_MASTER success", response);
        // commit mutation
        context.commit("setCurrentMaster", response);
        return response;
      })
      .catch(error => {
       Logger.debug("MASTER ACTION GET_MASTER error", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
  GET_MASTER_BY_SLUG(context, data) {
   Logger.debug("GET_MASTER_BY_SLUG", data);
    return API.getDocumentBySlug(data)
      .then(response => {
       Logger.debug("MASTER ACTION GET_MASTER_BY_SLUG success", response);
        // commit mutation
        context.commit("setCurrentMaster", response);
        return response;
      })
      .catch(error => {
       Logger.debug("MASTER ACTION GET_MASTER_BY_SLUG error", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
  GET_MASTERS: (context, data) => {
   Logger.debug("GET_MASTERS", data);

    return API.getDocuments(data)
      .then(response => {
       Logger.debug("MASTER ACTION GET_MASTERS success", response);
        // commit mutation
        context.commit("setMasters", response);
        return response;
        // you have your token, now log in your user :)
        //dispatch(USER_REQUEST)
      })
      .catch(error => {
       Logger.debug("MASTER ACTION GET_MASTERS Error", error);
        //Logger.error("GET_FRONTEND_USER Error ", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
  GET_MASTERS_COUNT: (context, data) => {
   Logger.debug("GET_MASTERS_COUNT", data);

    return API.getDocuments(data)
      .then(response => {
       Logger.debug("MASTER ACTION GET_MASTERS_COUNT success", response);
        // commit mutation
        const count = response && response.count ? response.count : 0;
        context.commit("setMastersCount", count);
        return count;
        // you have your token, now log in your user :)
        //dispatch(USER_REQUEST)
      })
      .catch(error => {
       Logger.debug("MASTER ACTION GET_MASTERS_COUNT Error", error);
        //Logger.error("GET_FRONTEND_USER Error ", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
  EXPORT_CAS_MASTERS: (context, data) => {
   Logger.debug("EXPORT_CAS_MASTERS", data);

    return API.exportCasData(data)
      .then(response => {
       Logger.debug("MASTER ACTION EXPORT_CAS_MASTERS success", response);
        // commit mutation
        //context.commit("setMasters", response);
        return response;
        // you have your token, now log in your user :)
        //dispatch(USER_REQUEST)
      })
      .catch(error => {
       Logger.debug("MASTER ACTION EXPORT_CAS_MASTERS Error", error);
        //Logger.error("GET_FRONTEND_USER Error ", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
  EXPORT_SOURCES_MASTERS: (context, data) => {
    Logger.debug("EXPORT_SOURCES_MASTERS", data);

    return API.exportSourcesData(data)
      .then(response => {
        Logger.debug("MASTER ACTION EXPORT_SOURCES_MASTERS success", response);
         return response;
      })
      .catch(error => {
        Logger.debug("MASTER ACTION EXPORT_SOURCES_MASTERS Error", error);
        //Logger.error("GET_FRONTEND_USER Error ", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
  EXPORT_MASTERS(context, data) {
   Logger.debug("EXPORT_MASTERS", data);
    return API.downloadResults(data)
      .then(response => {
       Logger.debug("MASTER ACTION EXPORT_MASTERS success", response);
        // commit mutation

        return response;
      })
      .catch(error => {
       Logger.debug("MASTER ACTION EXPORT_MASTERS error", error);
        throw error;
      })
      .finally(() => {
        //this.state.loading = false;
      });
  },
};

const mutations = {
  setMasters(state, payload) {
    state.masters = payload;
  },
  setCurrentMaster(state, payload) {
    state.currentMaster = payload;
  },
  setMastersCount(state, payload) {
    state.mastersCount = payload;
  }
};

const getters = {
  masters: state => {
    return state.masters;
  },
  currentMaster: state => {
    return state.currentMaster;
  },
  mastersCount: state => {
    return state.mastersCount;
  }
};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
